/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:22832a49-bdc3-4cb2-899a-2150af0a53ab",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_konbktovn",
    "aws_user_pools_web_client_id": "3pmfj8ff8qvk1d1hcheb8cau9a",
    "oauth": {},
    "aws_user_files_s3_bucket": "odagiriauto6277875f512a4bc0a5a44c0720611cc2153947-dev",
    "aws_user_files_s3_bucket_region": "ap-northeast-1",
    "aws_dynamodb_all_tables_region": "ap-northeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "odagiriautodb-dev",
            "region": "ap-northeast-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "odagiriautoapi",
            "endpoint": "https://zqxsdubx9i.execute-api.ap-northeast-1.amazonaws.com/dev",
            "region": "ap-northeast-1"
        }
    ],
    "aws_content_delivery_bucket": "odagiriauto-20201214162041-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "https://d1p83eo6k37cf5.cloudfront.net"
};


export default awsmobile;
